<template>
  <div v-show="isShow" class="dash_admin_box">
    <div style="display: block" class="dash_admin_box dash_commute_01">
      <div class="dash_admin_box_head">
        <p class="admin_box_title">공구별 대공종 실적</p>
      </div>
      <!-- 검색 Wrap -->
      <div class="option_wrap" style="display: flex">
        <div class="search_filter">
          <form>
            <select
              v-model="selectSiteId"
              class="search_option"
              @change="changeSite()"
            >
              <option
                v-for="item in accessSiteList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </form>
        </div>
      </div>
      <div v-show="displayGraph === true" class="option_wrap">
        <div class="search_filter">1</div>
        <div class="right_area">
          <div
            class="download_button"
            :class="graphTypeCount === true ? 'on' : ''"
          >
            <button type="button" @click="changeGraphType('count')">
              실적
            </button>
          </div>
          <div
            class="download_button"
            :class="graphTypeMonth === true ? 'on' : ''"
          >
            <button type="button" @click="changeGraphType('month')">
              월별추이
            </button>
          </div>
        </div>
      </div>

      <!-- 검색 Wrap //-->
      <div
        v-show="displayGraph === true && graphTypeCount === true"
        id="container"
        class="graph_wrap"
      >
        <v-chart class="chart" :option="option" events="click" autoresize />
      </div>

      <div
        v-show="displayGraph === true && graphTypeMonth === true"
        id="container"
        class="graph_wrap"
      >
        <v-chart class="chart" :option="optionMonth" autoresize />
      </div>

      <div v-show="displayList === true" class="dash_admin_box_table">
        <table>
          <thead>
            <tr>
              <th width="90">처리상태</th>
              <th>시험일</th>
              <th>시험번호</th>
              <th>시험구분</th>
              <th width="280">위치/부위</th>
              <th width="200">재료</th>
              <th>시험·검사항목</th>
              <th>시험성과</th>
              <th width="150">시험기준</th>
              <th width="100">판정</th>
              <th>작성자</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="pageParam.total === 0">
              <td colspan="12">검색 결과가 없습니다.</td>
            </tr>
            <template v-if="pageParam.total !== 0">
              <tr v-for="(item, index) in pageParam.content" :key="index">
                <td>
                  {{ displayStatus(item.bookStatus) }}
                </td>

                <td>
                  {{ item.testDay }}
                </td>
                <td @click="detail(item)">
                  {{ item.testNo }}
                </td>
                <td>
                  {{ getTestTypeValue(item.division) }}
                </td>
                <td v-html="enter2Br(item.location)" />
                <td>
                  {{ item.material }}
                </td>
                <td>
                  {{ item.testItem.name }}
                </td>
                <td>
                  {{ item.result }}
                </td>
                <td>
                  {{ item.standard }}
                </td>
                <td>
                  {{ displayJudgment(item.judgment) }}
                </td>
                <td>
                  {{ item.name }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <pagination
        v-show="displayList === true"
        :page-param="pageParam"
        :list-cnt="listParam.size"
        @pageCallback="pageCallback"
      />
    </div>
  </div>
</template>
<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import Pagination from "./layout/Pagination.vue";
import { getToday, toDayFormatAddDay } from "../utils/date";
import { mapGetters, mapActions, mapState } from "vuex";
import TestItemApi from "../api/TestItemApi";
import TestBookApi from "../api/TestBookApi";
import SiteApi from "../api/SiteApi";

import PlanCountApi from "../api/PlanCountApi";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";
import VChart from "vue-echarts";
import PopupModifyNoticeVue from "./detail/PopupCreateNotice.vue";
use([
  CanvasRenderer,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  LineChart,
  BarChart,
]);

export default {
  name: "TestBookList",
  components: { Pagination, DatePicker, VChart, PopupModifyNoticeVue },
  props: {
    siteId: {
      type: Number,
      default: null,
    },
    tabId: {
      type: Number,
      default: 1,
    },
  },
  data: () => {
    return {
      companyList: [],
      pageParam: { content: [] },
      listParam: {
        page: 1,
        size: 20,
        beginDate: toDayFormatAddDay(-7),
        endDate: getToday(),
        name: null,
      },
      testItemList: {},
      firstCode: null,
      accessSiteList: [],
      selectSiteId: null,
      siteYearPlanList: [],
      testItemDepth1: null,
      option: {},
      optionMonth: {},
      testItemName: [],
      testItemTotal: [],
      testItemMonth: [],
      testItemPlanCount: [],
      displayGraph: true,
      displayList: false,
      graphTypeCount: true,
      graphTypeMonth: false,
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(["getLang"]),
    ...mapState({}),
  },
  created() {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    async init() {
      this.selectSiteId = this.siteId;
      const response = await SiteApi.getSiteYearPlan(this.siteId);
      this.siteYearPlanList = response;
      if (this.siteYearPlanList.length > 0) {
        const today = this.getToday();
        const findSiteYear = this.siteYearPlanList.filter(
          (siteYear) => siteYear.beginDay <= today && siteYear.endDay >= today
        );
        if (findSiteYear.length > 0) {
          this.listParam.beginDate = findSiteYear[0].beginDay;
        } else {
          this.listParam.beginDate = toDayFormatAddDay(-7);
        }
      }
      this.mainStatistic();
      this.monthStatistic();
      this.getSiteList();
      this.fetchTestBook();
      this.testItem();
    },
    getToday: getToday,
    async getSiteList() {
      const response = await SiteApi.getSiteList();
      this.accessSiteList = response;
      console.log(this.accessSiteList);
    },
    onClickSearch() {
      this.listParam.page = 1;
      this.fetchTestBook();
    },
    testItem() {
      TestItemApi.getDepthList(1, this.siteId).then((res) => {
        this.testItemList = res;
        const defaultCode = { name: "공종전체", id: null, code: null };
        this.testItemList.unshift(defaultCode);
      });
    },
    changeSite() {
      this.mainStatistic();
      this.monthStatistic();
    },
    async fetchTestBook() {
      //TODO 구해야 됨
      this.listParam.siteId = this.selectSiteId;

      this.listParam.itemCode = this.firstCode;
      const response = await TestBookApi.testBookList(this.listParam);
      response.size = this.listParam.size;
      this.pageParam = response;
      this.pageParam.content.forEach((item) => {
        this.accessSiteList.forEach((site) => {
          if (item.siteId === site.id) {
            item.siteName = site.name;
          }
        });
      });
      console.log(response);
    },
    pageCallback(page) {
      this.listParam.page = page;
      this.fetchTestBook();
    },
    contentSubStr(str) {
      if (str) {
        str = str.replace(/<[^>]*>?/g, "");
        if (str.length > 10) {
          str = str.substr(0, 8) + "...";
        }
      }
      return str;
    },
    imgFaults(item) {
      var url = "/img/common/";
      if (item) url += "bullet_red_icon.png";
      else url += "bullet_green_icon.png";

      return url;
      //bullet_green_icon.png
      //bullet_red_icon.png
    },
    onClickExcel() {
      const url = "/testBooks/excel";

      TestBookApi.excelDown(url, this.listParam);
    },
    getNumber(index) {
      this.pageParam.total -
        ((this.listParam.page - 1) * this.listParam.size + index);
    },
    codeChange() {
      this.pageParam = { content: [] };
      this.listParam.itemCode = this.firstCode;
      this.fetchTestBook();
    },
    displayJudgment(judgment) {
      if (judgment === "pass") {
        return "합격";
      } else if (judgment === "fail") {
        return '<font color="red">불합격</font>';
      }
      return "-";
    },
    displayStatus(status) {
      if (status === "approval") return "결재완료";
      else return "결재대기";
    },
    getTestTypeValue(division) {
      if (division === "remicon") return "레미콘시험";
      else if (division === "inside") return "현장시험";
      else if (division === "request") return "의뢰시험";
      else return "-";
    },
    enter2Br(str) {
      if (!str) return "";
      return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    async mainStatistic() {
      const response = await PlanCountApi.mainStatistic(this.selectSiteId);
      this.testItemDepth1 = response;

      this.testItemName = [];
      this.testItemMonth = [];
      this.testItemTotal = [];
      this.testItemPlanCount = [];

      for (var item of this.testItemDepth1) {
        this.testItemName.push(item.name);
        this.testItemMonth.push(item.monthCount);
        this.testItemTotal.push(item.totalCount - item.monthCount);
        this.testItemPlanCount.push(item.planCount);
      }

      this.setup();
    },
    async monthStatistic() {
      const response = await PlanCountApi.monthlyCount(this.selectSiteId);
      var xAxisData = [];
      var codeName = [];
      var seriesData = [];
      for (var item of response) {
        if (item.month) {
          xAxisData.push(item.month);
        }
        codeName.push(item.name);
      }

      const newXAxisData = xAxisData.filter(
        (v, i) => xAxisData.indexOf(v) === i
      );
      const newCodeName = codeName.filter((v, i) => codeName.indexOf(v) === i);

      for (let i = 0; i < newCodeName.length; i++) {
        seriesData.push({
          name: newCodeName[i],
          type: "line",
          // stack: "Total",
          // areaStyle: {},
          emphasis: {
            focus: "series",
          },

          data: [],
        });
      }

      for (let i = 0; i < newCodeName.length; i++) {
        for (var data of response) {
          if (seriesData[i].name === data.name) {
            seriesData[i].data.push(data.monthCount);
          }
        }
      }

      this.setupMonth(newXAxisData, newCodeName, seriesData);
    },
    changeDisplay(type) {
      if (type === "graph") {
        this.displayGraph = true;
        this.displayList = false;
      } else if (type === "list") {
        this.displayGraph = false;
        this.displayList = true;
      }
    },
    changeGraphType(type) {
      if (type === "count") {
        this.graphTypeCount = true;
        this.graphTypeMonth = false;
      } else if (type === "month") {
        this.graphTypeCount = false;
        this.graphTypeMonth = true;
      }
    },
    setup() {
      this.option = {
        grid: {
          top: 40,
          bottom: 50,
          left: 30,
          right: 0,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow",
          },
          data: this.testItemName,
          boundaryGap: true,
          axisLabel: {
            rotate: 20,
            interval: 0,
            // X축 폰트 크기
            show: true,
            fontSize: 8,
            // color: "rgba(255, 255, 255, 0.5)",
            color: "#8D8D8D",
            textStyle: {
              fontSize: 12,
              fontWeight: "bolder",
            },
          },
          axisLine: {
            // X축 라인 컬러
            lineStyle: {
              color: "rgba(255, 255, 255, 0.2)",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // Y축 폰트 크기
            fontSize: 11,
            color: "rgba(255, 255, 255, 0.5)",
          },
          splitLine: {
            // 차트 중간선 컬러
            lineStyle: {
              color: "rgba(255, 255, 255, 0.1)",
            },
          },
        },
        legend: {
          data: ["계획", "누계", "금월"],
          textStyle: {
            color: "#ccc",
            fontSize: 20,
            fontFamily: "sans-serif",
          },
        },
        series: [
          {
            data: this.testItemPlanCount,
            type: "line",
            name: "계획",
            barWidth: "10%",
            showBackground: true,
            emphasis: {
              focus: "series",
            },
            areaStyle: {
              opacity: 0.3,
            },
          },
          {
            data: this.testItemTotal,
            type: "bar",
            name: "누계",
            barWidth: "10%",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.15)",
            },
            itemStyle: {
              color: "rgba(100, 255, 1, 0.6)",
            },
            emphasis: {
              focus: "series",
            },
            stack: "x",
          },
          {
            data: this.testItemMonth,
            type: "bar",
            name: "금월",
            barWidth: "10%",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.15)",
            },
            itemStyle: {
              color: "rgba(185, 80, 245, 0.6)",
            },
            emphasis: {
              focus: "series",
            },
            stack: "x",
          },
        ],
      };
    },

    setupMonth(xAxisData, codeName, seriesData) {
      this.optionMonth = {
        grid: {
          top: 40,
          bottom: 50,
          left: 30,
          right: 0,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis: {
          type: "category",
          axisPointer: {
            type: "shadow",
          },
          data: xAxisData,
          boundaryGap: true,
          axisLabel: {
            rotate: 20,
            interval: 0,
            // X축 폰트 크기
            show: true,
            fontSize: 8,
            // color: "rgba(255, 255, 255, 0.5)",
            color: "#8D8D8D",
            textStyle: {
              fontSize: 12,
              fontWeight: "bolder",
            },
          },
          axisLine: {
            // X축 라인 컬러
            lineStyle: {
              color: "rgba(255, 255, 255, 0.2)",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            // Y축 폰트 크기
            fontSize: 11,
            color: "rgba(255, 255, 255, 0.5)",
          },
          splitLine: {
            // 차트 중간선 컬러
            lineStyle: {
              color: "rgba(255, 255, 255, 0.1)",
            },
          },
        },
        legend: {
          data: codeName,
          textStyle: {
            color: "#ccc",
            fontSize: 20,
            fontFamily: "sans-serif",
          },
        },
        series: seriesData,
      };
    },
    open() {
      this.init();
      this.isShow = true;
    },
    close() {
      this.isShow = false;
    },
    detail(item) {
      console.log(item);
      //TODO 팝업 테스트
      this.$refs.popupDetail.open(item);
    },
    test() {
      console.log("sefsef");
    },
  },
};
</script>
<style scoped>
.option_wrap {
  display: block;
}
</style>
